<template>
  <dv-scroll-board :config="config" style="width:100%;height:100%;" />
</template>
<script>
export default {
  name: "List1",
  data() {
    return {
      config: {},
    }
  },
  methods:{

  },
  created() {

      
      let data=[];
      data[0]=['伊利牛奶','市第一小学','80'];
      data[1]=['光明牛奶','市第三小学','149'];
      data[2]=['蒙牛牛奶','市第四小学','126'];
      data[3]=['旺旺牛奶','市第二小学','115'];
      data[4]=['伊利酸奶','市第五小学','156'];
      data[5]=['光明酸奶','市第一小学','168'];
      data[6]=['蒙牛酸奶','市第四小学','119'];
      data[7]=['旺旺酸奶','市第五小学','65'];


      this.config = {
        header: [ '商品名称', '设备地点', '今日交易额'],
        rowNum:[4],
        data: data,
        headerBGC: '#0081EE',
        oddRowBGC: '#0e0e26',
        evenRowBGC: '#0e0e26',
        index: true,
        columnWidth: [80,300,275,275],
        align: ['center']
      }
   

  },

  watch: {

  }
}
</script>

<style scoped>
.galleries {
  width: 100%;
  height: 100%;
}
</style>